<template>
  <div class="">
    <div @click="toggleDropdown" class="pointer bimplus-select-dropdown is-size-3">
      <span v-if="!$_.isEmpty(appliedSelection)" class="text-truk-message">
        {{ appliedSelectionLabel }}
      </span>
      <span v-else>Make Selection</span>
      <i :class="!dropdownOpen ? 'icon-disclosearrow is-pulled-right' : 'icon-disclosearrow fa-rotate-180 is-pulled-right'"></i>
    </div>
    <VDropdown v-if="dropdownOpen" :shown="dropdownOpen">
      <template #popper>
        <div class="card bimplus-select-modal">
          <div class="bimplus-select-body">
            <div v-for="option in options" :class="option._id === tempSelection._id ? 'active-item' : ''"
                :key="option._id" class="select-item is-clickable" @click="setOption(option)">
              {{ option.name }}
            </div>            
          </div>
          <div class="bimplus-select-footer">
            <div class="py-2 is-flex is-justify-content-flex-end">
              <button @click="cancelSelection" class="button is-outlined mr-2">Cancel</button>
              <button @click="applySelection(false)" :disabled="disableApply" class="button has-background-black-bis has-text-white mr-2">Apply</button>
              <button v-if="showApplyAll" @click="applySelection(true)" :disabled="disableApply" class="button has-background-black-bis has-text-white">Apply All</button>
            </div>
          </div>
        </div>
      </template>
    </VDropdown>
  </div>
</template>
<script>

  import { isEmpty } from 'lodash';
  import { computed, onMounted, reactive, toRefs } from 'vue'

  export default {
    name: 'Selectoptions',
    props: {
      modelValue: [Number, String, Object, Array, Boolean],
      titleLabel: {
        type: String,
        default: '',
      },
      labelPosition: {
        type: String,
        default: 'top',
      },
      disabled: [Boolean, Function, String],
      options: {
        type: [Array, Object, Function],
        required: false,
        default: () => [],
      },
      labelClass: String,
      displayType: {
        type: String,
        default: '',
      },
      displayProp: {
        type: String,
        default: '',
      },
      noDirtyEmit: {
        type: Boolean,
        default: false,
      },
      selectedWorkstep: {},
      showApplyAll: {
        type: Boolean,
        default: true,
      },
    },
    setup(props, { attrs, emit }) {
      const state = reactive({
        dropdownOpen: false,
        appliedSelection: !isEmpty(props.modelValue) ? props.modelValue : {},
        tempSelection: {},
        applyToAll: false,
        disableApply: true,
      });

      const appliedSelectionLabel = computed(() => state.appliedSelection.name ? state.appliedSelection.name : state.appliedSelection);
    
      const toggleDropdown = () => {
        state.dropdownOpen = !state.dropdownOpen
        if (state.dropdownOpen) {
          state.tempSelection = state.appliedSelection;
        }
      }

      const setOption = (option) => {
        state.tempSelection = option;
        state.disableApply = false;
      }
    
      const applySelection = (val) => {
        state.applyToAll = val;
        state.appliedSelection = state.tempSelection;
        emit('update:modelValue', {value: state.appliedSelection, applyToAll: state.applyToAll});
        state.dropdownOpen = false;
        state.applyToAll = false;
        state.disableApply = true;
      }
    
      const cancelSelection = () => {
        state.tempSelection = state.appliedSelection
        state.dropdownOpen = false;
        state.applyToAll = false;
        state.disableApply = true;
      }
    
      onMounted(() => {
        state.tempSelection = state.appliedSelection
      });

      return {
        ...toRefs(state),
        toggleDropdown,
        applySelection,
        cancelSelection,
        appliedSelectionLabel,
        setOption,
      }
    }
  }

</script>
<style scoped>
.bimplus-select-footer {
  border-top: 1px solid #808080;
  background-color: #fff;
  z-index: 2;
  bottom: 1px;
  width: 97%;
  position: fixed;
  padding-right: 6px;
}
</style>